import { ChevronRightIcon } from '@chakra-ui/icons';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';

export type BreadcrumbProps = {
  label: string;
  path?: string;
};

type BreadcrumbsProps = { breadcrumbs: BreadcrumbProps[] };
export const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  const { pathname: currentPath, search: currentSearch } = useLocation();
  return (
    <Breadcrumb
      spacing="8px"
      separator={<ChevronRightIcon color={colors.gray[500]} />}
      fontSize="xs"
      color={colors.gray[500]}
    >
      {_.map(breadcrumbs, (breadcrumb, index) => {
        return (
          <BreadcrumbItem
            isCurrentPage={index === breadcrumbs.length - 1}
            key={`${breadcrumb.label}-${breadcrumb.path}`}
          >
            <BreadcrumbLink
              as={Link}
              to={breadcrumb.path ?? `${currentPath}${currentSearch}`}
            >
              {breadcrumb.label}
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};
